import React from 'react';
import HeroSection from '../components/HeroSection';
import ConsulenzaSection from '../components/ConsulenzaSection';
import AboutSection from '../components/AboutSection';
import FeaturedServices from '../components/FeaturedServices';
import WhatIDoSection from '../components/WhatIDoSection';
import ContactSection from '../components/ContactSection';

function Home() {
    return (
        <div>
            <HeroSection />
            {/*<ServicesSection />*/}
            <ConsulenzaSection />
            <AboutSection />
            <FeaturedServices />
            <WhatIDoSection />
            <ContactSection />
        </div>
    );
}

export default Home;